export default __webpack_public_path__ + "static/media/photo-camera.e49e2ef8.svg";